import { queryClient } from '../../../../v4/migration/queryClientSingleton';
import { myReduxProxy } from '../../../api/_common/reduxProxy.connected';
import { myShortlistBoardApi } from '../../../api/shortlist-board/shortlistBoard.api.connected';
import { myErrorService } from '../../front/ErrorService/ErrorService.connected';
import { myMessageService } from '../../internal/MessageService/MessageService.connected';
import { myMetastructureMappingService } from '../../internal/MetastructureMappingService/MetastructureMappingService.connected';
import { createShortlistBoardService } from './ShortlistBoardService.impl';

export const myShortlistBoardService = createShortlistBoardService({
  api: myShortlistBoardApi,
  queryClient,
  reduxProxy: myReduxProxy,
  services: {
    errorService: myErrorService,
    messageService: myMessageService,
    metastructureMappingService: myMetastructureMappingService
  }
});
